"use client";
import s, { useRef as h, useEffect as i } from "react";
import { Chart as l, BarController as g, LineController as C, CategoryScale as E, LinearScale as x, BarElement as y, PointElement as L, LineElement as v, Title as k, Tooltip as B, Legend as F, Filler as R } from "./index.es64.js";
import { Chart as T } from "./index.es65.js";
import b from "./index.es66.js";
import j from "./index.es67.js";
import z from "./index.es68.js";
import I from "./index.es59.js";
import N from "./index.es69.js";
const S = I.div`
  position: relative;
  min-height: 500px;
`;
l.register(
  g,
  C,
  b,
  z,
  E,
  x,
  y,
  L,
  v,
  k,
  B,
  F,
  R,
  j,
  N
);
l.defaults.font.size = 16;
const W = ({
  data: t,
  options: m,
  type: c,
  highlightLabel: r,
  keyContext: d,
  onChartChange: o
}) => {
  const e = h(void 0);
  i(() => (e.current && o && o(e.current), () => {
    e.current && e.current.destroy();
  }), []);
  const f = (p) => {
    if (t.datasets) {
      const a = t.datasets.findIndex(
        (n) => n.label === p
      );
      if (a >= 0)
        return t.datasets[a].data.map((n, u) => ({
          datasetIndex: a,
          index: u
        }));
    }
    return [];
  };
  return i(() => {
    e.current && e.current.setActiveElements(
      f(r || "")
    );
  }, [r]), /* @__PURE__ */ s.createElement(S, { className: "chartjs-wrapper", "aria-hidden": "true" }, /* @__PURE__ */ s.createElement(
    T,
    {
      ref: e,
      key: d,
      data: t,
      options: m,
      type: c
    }
  ));
};
export {
  W as default
};
//# sourceMappingURL=index.es25.js.map
